import AppLogo from '../AppLogo';
import Menu from '../Menu';
import SidebarLogin from '../../SidebarLogin';

import useStyles from './styles';

function EditorSidebar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <AppLogo />
      </div>
      <Menu />
      <SidebarLogin />
    </div>
  );
}
export default EditorSidebar;
